import { CodeType, OrderItemType } from '../../api/order';

export type OrderItmesTablePropsType = {
  orderItems: OrderItemType[];
  code: CodeType | null;
  totalPrice: number;
  paymentPrice: number;
  creditPrice: number;
};

function OrderItemsTable({
  orderItems,
  code,
  totalPrice,
  paymentPrice,
  creditPrice
}: OrderItmesTablePropsType) {
  return (
    <div className='my-4'>
      <p className='font-medium'>بسته‌های انتخاب شده:</p>
      <table className='my-4 w-full border-collapse border border-green-600 lg:w-1/2'>
        <thead>
          <tr>
            <th className='border border-green-400 py-1.5'>#</th>
            <th className='border border-green-400 py-1.5'>نام بسته</th>
            <th className='border border-green-400 py-1.5'>قیمت بسته</th>
          </tr>
        </thead>
        <tbody>
          {orderItems
            .sort((p1, p2) => p2.item.weight - p1.item.weight)
            .map((pkg, index) => (
              <tr key={pkg.id}>
                <td className='border border-green-400 py-1.5 text-center'>{index + 1}</td>
                <td className='border border-green-400 py-1.5 text-center'>{pkg.name}</td>
                <td className='border border-green-400 py-1.5 text-center'>
                  <span>{pkg.price ? `${pkg.price.toLocaleString()} ریال` : 'رایگان'}</span>
                </td>
              </tr>
            ))}
        </tbody>
        <tfoot>
          <tr>
            <td className='border border-green-400 py-1.5 text-center font-medium' colSpan={2}>
              مجموع
            </td>
            <td className='border border-green-400 py-1.5 text-center font-medium'>
              {totalPrice ? `${totalPrice.toLocaleString()} ریال` : 'رایگان'}
            </td>
          </tr>

          {!!code && (
            <tr>
              <td className='border border-green-400 py-1.5 text-center font-medium' colSpan={2}>
                <span>مجموع پس از اعمال کد تخفیف </span>
                <span>{` (${code.amount}%) `}</span>
              </td>
              <td className='border border-green-400 py-1.5 text-center font-medium'>
                {`${paymentPrice.toLocaleString()} ریال`}
              </td>
            </tr>
          )}
          {creditPrice !== 0 && (
            <tr>
              <td className='border border-green-400 py-1.5 text-center font-medium' colSpan={2}>
                <span>مجموع پس از کسر مبلغ </span>
                <span>{`${creditPrice.toLocaleString()} ریال`}</span>
                <span> از اعتبار شما</span>
              </td>
              <td className='border border-green-400 py-1.5 text-center font-medium'>
                {`${(paymentPrice - creditPrice).toLocaleString()} ریال`}
              </td>
            </tr>
          )}
        </tfoot>
      </table>
    </div>
  );
}

export default OrderItemsTable;
